import { render, staticRenderFns } from "./SalesOrderDetails.vue?vue&type=template&id=3af1f835&scoped=true&"
import script from "./SalesOrderDetails.vue?vue&type=script&lang=ts&"
export * from "./SalesOrderDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SalesOrderDetails.vue?vue&type=style&index=0&id=3af1f835&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af1f835",
  null
  
)

export default component.exports